import { css } from '@emotion/core';
import { variables, media } from '@domain-group/fe-brary';
var colour = variables.colour,
  font = variables.font;
export var container = /*#__PURE__*/css("display:block;margin-top:24px;", media('>=tablet'), "{max-width:316px;display:inline-block;}", media('>=desktop'), "{max-width:340px;}");
export var title = /*#__PURE__*/css("color:", colour.neutral600, ";font-family:", font.headingFontFamily, ";font-size:", font.h4FontSize, ";font-weight:", font.headingFontWeight, ";", media('>=tablet'), "{color:", colour.neutral700, ";}");
var _ref = {
  name: "x97jm9",
  styles: "height:auto;"
};
export var image = empty => /*#__PURE__*/css("width:100%;height:auto;margin-top:24px;", media('>=tablet'), "{width:308px;height:308px;}", media('>=desktop'), "{width:320px;}", empty && _ref);
export var imageContainer = {
  name: "79elbk",
  styles: "position:relative;"
};
export var noImageText = /*#__PURE__*/css("position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100%;text-align:center;color:", colour.neutral700, ";font-family:", font.bodyFontFamily, ";font-size:", font.baseFontSize, ";");
export var link = {
  name: "ytumd6",
  styles: "text-decoration:none;"
};
export var infoItem = /*#__PURE__*/css("text-align:left;color:", colour.neutral700, ";font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";");
export var disclaimerText = /*#__PURE__*/css("display:inline-block;color:", colour.neutral500, ";font-family:", font.bodyFontFamily, ";font-size:12px;text-align:left;margin-top:4px;line-height:normal;");